import LineOrBarChartRenderer from 'webapp/d-chart/renderer/line-or-bar-chart';
import SimpleChartRenderer from 'webapp/d-chart/renderer/simple-line-chart';

export default class ForecastChartSmallRenderer extends SimpleChartRenderer {
	override get series() {
		return this.visualization.series;
	}

	protected override getDefs() {
		const forecastsGradientDefs = LineOrBarChartRenderer.getForecastsGradientDefs();
		return [...this.mainGradientDefs, ...forecastsGradientDefs];
	}
}
